import { configureStore } from '@reduxjs/toolkit';
import auth from './reducers/authSlice';
import user from './reducers/userSlice';
import roles from './reducers/rolesSlice';
import activeAccount from './reducers/accountSlice';
import payment from './reducers/paymentGatewaySlice';
import transactionCart from './reducers/transactionCart';

export const store = configureStore({
  reducer: {
    auth,
    user,
    activeAccount,
    roles,
    payment,
    transactionCart,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types, blobs not serializable
        ignoredActions: ['userInfo/storeUserProfileImageBlobUrl'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['user.profileImageBlob'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
